import React, { PureComponent } from 'react'
import TopBarContainer from '../components/topbar/TopbarContainer'
import Sidebar from '../components/sidebar/Sidebar'
import { withRouter } from 'react-router-dom'

class AuthLayout extends PureComponent {
  render() {
    return (
      <div>
        <TopBarContainer />
        <Sidebar />
      </div>
    )
  }
}

export default withRouter(AuthLayout);



// WEBPACK FOOTER //
// ./src/layouts/AuthLayout.js